module.exports = __webpack_public_path__ + "static/img/active_03.4d3d4ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_03.jpg
// module id = V6hY
// module chunks = 0